export default __webpack_public_path__ + "static/media/floor-8.736f9143.jpg";